import React, { useMemo, useEffect, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { logSystemError } from '../firebase/systemLogger';
import './NotFound.css';

function NotFound() {
  const location = useLocation();
  const { userProfile } = useAuth();
  const hasLogged = useRef(false);
  
  // Generate a professional Error ID like Vercel/Cloudflare
  const errorId = useMemo(() => {
    const chars = 'abcdef0123456789';
    let result = '';
    for (let i = 0; i < 12; i++) {
      result += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return `ER404-${result.toUpperCase()}`;
  }, []);

  // Log 404 to Admin Portal
  useEffect(() => {
    if (!hasLogged.current) {
      logSystemError(
        errorId, 
        `User encountered a 404 page not found.`, 
        location.pathname, 
        userProfile?.suid || userProfile?.adminId || 'GUEST'
      );
      hasLogged.current = true;
    }
  }, [errorId, location.pathname, userProfile]);

  return (
    <div className="notfound-page">
      <div className="notfound-card">
        <div className="notfound-header">
          <div className="status-code">404</div>
          <div className="status-sep"></div>
          <div className="status-text">NOT_FOUND</div>
        </div>

        <div className="notfound-content">
          <p>The page you are looking for does not exist on this server.</p>
          
          <div className="error-details">
            <div className="detail-item">
              <span className="label">Code:</span>
              <code>NOT_FOUND</code>
            </div>
            <div className="detail-item">
              <span className="label">Path:</span>
              <code>{location.pathname}</code>
            </div>
            <div className="detail-item">
              <span className="label">ID:</span>
              <code>{errorId}</code>
            </div>
          </div>

          <div className="notfound-actions">
            <Link to="/" className="notfound-link">
              <i className="fa-solid fa-arrow-left"></i>
              Return to DevTracker Home
            </Link>
            <a href="https://github.com/DevTracker" className="notfound-link secondary">
              Report this failure
            </a>
          </div>
        </div>

        <div className="vercel-footer">
          <span>Powered by</span>
          <div className="logo-group">
            <i className="fa-solid fa-code-merge"></i>
            <strong>DevTracker AI</strong>
          </div>
        </div>
      </div>
    </div>
  );
}

export default NotFound;
